export default "__VITE_ASSET__Dlr2s34K__"